import { useEffect, useRef, useState } from 'react'
import { LocalStorageService, BranchOfficeService } from "../../../services"
import { BranchOfficeDetailsView } from "../../views"
import { ModalUtil } from "../../pures"
import { useHistory, useLocation } from "react-router-dom"
import { useTranslation } from 'react-i18next'

const BranchOfficeDetailsAction = () => {
  const { t: transl } = useTranslation('branch-office', { keyPrefix: 'branchOfficeDetails' });
  const { t } = useTranslation()

  const location = useLocation()
  const queryParameters = new URLSearchParams(location.search)
  const branchOfficeId = queryParameters.get('branchOfficeId')

  const [edit, setEdit] = useState(false)
  const history = useHistory()
  const nameRef = useRef(null)
  const keyIdentifierRef = useRef(null)
  const zipCodeRef = useRef(null)
  const cityRef = useRef(null)
  const stateRef = useRef(null)
  const countryRef = useRef(null)
  const [coordinates, setCoordinates] = useState({ lat: '23.866980789984908', long: '-102.48693758189374' })
  const [fullAddress, setFullAddress] = useState('')

  const url = process.env.REACT_APP_ETICKET_API
  const localStorageService = new LocalStorageService()
  const branchOfficeService = new BranchOfficeService(url)
  const modalUtil = new ModalUtil()

  useEffect(() => {
    if (branchOfficeId) {
      // execute function that retrieve the information
      getBranchOfficeInformation()
    }
  }, [])

  const editEnabled = () => { setEdit(true) }

  const createNewBranchOffice = async () => {
    try {
      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
      const token = localStorageService.getLocalStorageItem('token').accessToken
      // El valor vacio debiera ser la direccion completa, se obtendra del mapa junto con las coordenadas.
      const branchOffice = await branchOfficeService.createBranchOffice(nameRef.current.value, zipCodeRef.current.value, cityRef.current.value, stateRef.current.value, countryRef.current.value, keyIdentifierRef.current.value, fullAddress, coordinates, token)
      if (branchOffice.id) modalUtil.showModal('success', transl('branchOfficeAdded'), t("modal.pure.title.success"), () => history.push('/branch-offices-administration'))
    } catch (error) {
      console.log(error)
      modalUtil.showModal('error', error.message || transl('errorBranchOfficePut'), t("modal.pure.title.error"))
    }
  }

  const updateBranchOffice = async () => {
    try {
      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
      const token = localStorageService.getLocalStorageItem('token').accessToken

      let coordinatesAux = {}
      if (coordinates.lat !== '23.866980789984908' && coordinates.long !== '-102.48693758189374') coordinatesAux = coordinates
      const branchOffice = await branchOfficeService.updateBranchOffice(branchOfficeId, nameRef.current.value, zipCodeRef.current.value, cityRef.current.value, stateRef.current.value, countryRef.current.value, keyIdentifierRef.current.value, fullAddress, coordinatesAux, token)
      if (branchOffice.id) modalUtil.showModal('success', transl('branchOfficeEdited'), t("modal.pure.title.success"), () => history.push('/branch-offices-administration'))
    } catch (error) {
      console.log(error)
      modalUtil.showModal('error', transl('errorBranchOfficePut'), t("modal.pure.title.error"))
    }
  }

  const getBranchOfficeInformation = async () => {
    try {
      const token = localStorageService.getLocalStorageItem('token').accessToken
      const branchOffice = await branchOfficeService.getBranchOfficeById(branchOfficeId, token)

      // Showing the variables here
      nameRef.current.value = branchOffice.name
      keyIdentifierRef.current.value = branchOffice.keyIdentifier
      zipCodeRef.current.value = branchOffice.zipCode
      cityRef.current.value = branchOffice.city
      stateRef.current.value = branchOffice.state
      countryRef.current.value = branchOffice.country
      if (branchOffice.coordinates?.lat && branchOffice.coordinates?.long) setCoordinates(branchOffice.coordinates)
    } catch (error) {
      console.log(error)
      modalUtil.showModal('error', transl('errorBranchOffice'), t("modal.pure.title.error"))
    }
  }

  let onClickPrimaryButton

  if (!edit && branchOfficeId) {
    onClickPrimaryButton = editEnabled
  } else if (edit && branchOfficeId) {
    onClickPrimaryButton = updateBranchOffice
  } else {
    onClickPrimaryButton = createNewBranchOffice
  }

  return <BranchOfficeDetailsView
    nameRef={nameRef}
    keyIdentifierRef={keyIdentifierRef}
    zipCodeRef={zipCodeRef}
    cityRef={cityRef}
    stateRef={stateRef}
    countryRef={countryRef}
    edit={edit}
    branchOfficeId={branchOfficeId}
    onClickPrimaryButton={onClickPrimaryButton}
    setCoordinates={setCoordinates}
    setFullAddress={setFullAddress}
    coordinates={coordinates}
  />
}

export default BranchOfficeDetailsAction